import React, { Component } from 'react';
import { Table } from 'reactstrap';
import LocationsImportFile from '../ImportFile/LocationsImportFile';
import DepartmentImportFile from '../ImportFile/DepartmentsImportfile';
import EmployeesImportFile from './EmployeesImportfile';
import PositionsImportFile from './PositionsImportfile';
import ProjectsImportFile from './ProjectsImportfile';
import JobsImportFile from './JobsImportfile';
import PTOImportFile from './PTOImportfile';
import EasyClockingImportFile from './EasyClockingImportfile';
import TimelogImportFile from './TimelogImportfile';
import MainLayout from '../layout/layout';
import { Redirect } from 'react-router-dom';
import RolesType from '../utils/roles';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomerInfoService from '../Services/CustomerInformationService/customerInformationService';
import { ClipLoader } from 'react-spinners';
import { css } from 'react-emotion';


//Migration Tool Menu

const SelectedCss = {
    backgroundColor: '#6DB3E1',
    color: 'white'
}
const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
const NotSelectedCss = {

}

class ImportFile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            CompanyCode: "",
            MaxUser: "",
            ProductCode: "",
            UsersActive: "",
            ExpirationDate: "",
            CompanyName: "",
            loading: false,
            isAutenticated: true
        };
        this.companyCodeValueV = this.companyCodeValueV.bind(this);
        this.hanldeKeyPress = this.hanldeKeyPress.bind(this);
    }

    hanldeKeyPress(e) {
        if (e.keyCode === 13) {
            this.getCustomerInfo();
        }
    }
    getCustomerInfo() {

        var CompanyCode = this.state.CompanyCode;
        var email = sessionStorage.getItem('email');
        var that = this;
        this.setState({
            loading: true
        });
        var DataResult = CustomerInfoService.getCustomerInformation(CompanyCode, email);
        DataResult.then(function (data) {
            if (data.statusText === "OK" && data.data !== "NoDB" && data.data !== "NotFound") {
                that.setState({
                    CompanyName: data.data.CompanyName,
                    MaxUser: data.data.MaxUsers,
                    ProductCode: data.data.ProductCode,
                    UsersActive: data.data.UsersActive,
                    ExpirationDate: data.data.ExpirationDate,
                    loading: false
                });
            }
        }).catch((error) => {
            that.setState({
                CompanyName: "",
                MaxUser: "",
                ProductCode: "",
                UsersActive: "",
                ExpirationDate: "",
                loading: false,
                LocationsActive: false,
                DepartmentsActive: false,
                EmployeesActive: false,
                ProjectsActive: false,
                JobsActive: false,
                PTOActive: false,
                PositionsActive: false,
                EasyClockingActive: false,
                TimelogsActive: false,
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    companyCodeValueV(e) {
        e.preventDefault();

        let stateCopy = Object.assign({}, this.state);
        stateCopy.CompanyCode = e.target.value;
        stateCopy.CompanyName = "";
        stateCopy.MaxUser = "";
        stateCopy.ProductCode = "";
        stateCopy.UsersActive = "";
        stateCopy.ExpirationDate = "";
        this.setState(stateCopy);
    }
    componentDidMount() {

    }
    getID(e, id) {
        e.preventDefault();
        if (id === "LOCATIONS") {
            this.setState({
                LocationsActive: true,
                DepartmentsActive: false,
                EmployeesActive: false,
                ProjectsActive: false,
                JobsActive: false,
                PTOActive: false,
                PositionsActive: false,
                EasyClockingActive: false,
                TimelogsActive: false,
            });
        } else if (id === "DEPARTMENTS") {
            this.setState({
                LocationsActive: false,
                DepartmentsActive: true,
                EmployeesActive: false,
                ProjectsActive: false,
                JobsActive: false,
                PTOActive: false,
                PositionsActive: false,
                EasyClockingActive: false,
                TimelogsActive: false,
            });
        } else if (id === "EMPLOYEES") {
            this.setState({
                LocationsActive: false,
                DepartmentsActive: false,
                EmployeesActive: true,
                ProjectsActive: false,
                JobsActive: false,
                PTOActive: false,
                PositionsActive: false,
                EasyClockingActive: false,
                TimelogsActive: false,
            });
        } else if (id === "POSITIONS") {
            this.setState({
                LocationsActive: false,
                DepartmentsActive: false,
                EmployeesActive: false,
                ProjectsActive: false,
                JobsActive: false,
                PTOActive: false,
                PositionsActive: true,
                EasyClockingActive: false,
                TimelogsActive: false,
            });
        } else if (id === "PROJECTS") {
            this.setState({
                LocationsActive: false,
                DepartmentsActive: false,
                EmployeesActive: false,
                ProjectsActive: true,
                JobsActive: false,
                PTOActive: false,
                PositionsActive: false,
                EasyClockingActive: false,
                TimelogsActive: false,
            });
        } else if (id === "JOBS") {
            this.setState({
                LocationsActive: false,
                DepartmentsActive: false,
                EmployeesActive: false,
                ProjectsActive: false,
                JobsActive: true,
                PTOActive: false,
                PositionsActive: false,
                EasyClockingActive: false,
                TimelogsActive: false,
            });
        } else if (id === "PTO") {
            this.setState({
                LocationsActive: false,
                DepartmentsActive: false,
                EmployeesActive: false,
                ProjectsActive: false,
                JobsActive: false,
                PTOActive: true,
                PositionsActive: false,
                EasyClockingActive: false,
                TimelogsActive: false,
            });
        } else if (id === "EasyClocking") {
            this.setState({
                LocationsActive: false,
                DepartmentsActive: false,
                EmployeesActive: false,
                ProjectsActive: false,
                JobsActive: false,
                PTOActive: false,
                PositionsActive: false,
                EasyClockingActive: true,
                TimelogsActive: false,
            });
        } else if (id === "Timelogs") {
            this.setState({
                LocationsActive: false,
                DepartmentsActive: false,
                EmployeesActive: false,
                ProjectsActive: false,
                JobsActive: false,
                PTOActive: false,
                PositionsActive: false,
                EasyClockingActive: false,
                TimelogsActive: true,
            });
        }
    }
    renderImportFileRow() {
        let dataResult = RolesType;
        let renderImport = this.state.MaxUser !== "" ? this.renderImportType() : null;

        var temp = Object.keys(dataResult);
        if (sessionStorage.getItem("rol") === temp[0] || sessionStorage.getItem("rol") === temp[1] || sessionStorage.getItem("rol") === temp[2] || sessionStorage.getItem("rol") === temp[4] ||
            sessionStorage.getItem("rol") === temp[5]) {
            return (<div>
                <div className="row">
                    <div className="col-2" >
                        <div className="card Logs">
                            <div className="card-header">
                                <div className="row" id="timelogs_filter">
                                    <div className="col-lg-1 col-md-1 col-sm-1">
                                        <label className="control-label" style={{ 'fontWeight': 'bold' }}>Items</label>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body divCardRealtime" style={{ 'height': '320px' }}>
                                {
                                    /*this.state.CompanyCode && this.state.CompanyName
                                    &&*/
                                    <Table borderless responsive size="sm" striped>
                                        <tbody style={{ 'cursor': 'pointer' }} >
                                            <tr style={this.state.LocationsActive ? SelectedCss : NotSelectedCss} id="LOCATIONS" onClick={(e) => this.getID(e, "LOCATIONS")}>
                                                <td style={{ 'fontWeight': 'normal' }}>Locations</td>
                                            </tr>
                                            <tr style={this.state.DepartmentsActive ? SelectedCss : NotSelectedCss} id="DEPARTMENTS" onClick={(e) => this.getID(e, "DEPARTMENTS")}>
                                                <td style={{ 'fontWeight': 'normal' }}>Departments</td>
                                            </tr>
                                            <tr style={this.state.EmployeesActive ? SelectedCss : NotSelectedCss} id="EMPLOYEES" onClick={(e) => this.getID(e, "EMPLOYEES")}>
                                                <td style={{ 'fontWeight': 'normal' }}>Employees</td>
                                            </tr>
                                            <tr style={this.state.PositionsActive ? SelectedCss : NotSelectedCss} id="POSITIONS" onClick={(e) => this.getID(e, "POSITIONS")}>
                                                <td style={{ 'fontWeight': 'normal' }}>Positions</td>
                                            </tr>
                                            <tr style={this.state.ProjectsActive ? SelectedCss : NotSelectedCss} id="PROJECTS" onClick={(e) => this.getID(e, "PROJECTS")}>
                                                <td style={{ 'fontWeight': 'normal' }}>Projects</td>
                                            </tr>
                                            <tr style={this.state.JobsActive ? SelectedCss : NotSelectedCss} id="JOBS" onClick={(e) => this.getID(e, "JOBS")}>
                                                <td style={{ 'fontWeight': 'normal' }}>Jobs</td>
                                            </tr>
                                            <tr style={this.state.PTOActive ? SelectedCss : NotSelectedCss} id="PTO" onClick={(e) => this.getID(e, "PTO")}>
                                                <td style={{ 'fontWeight': 'normal' }}>PTO Balance</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                }
                            </div>
                        </div>
                        <div className="card Logs">
                            <div className="card-header">
                                <div className="row" id="timelogs_filter">
                                    <div className="col-lg-1 col-md-1 col-sm-1">
                                        <label className="control-label" style={{ 'fontWeight': 'bold' }}>Timelogs</label>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body divCardRealtime" style={{ 'height': '200px' }}>
                                <Table borderless responsive size="sm" striped>
                                    <tbody style={{ 'cursor': 'pointer' }} >
                                        <tr style={this.state.EasyClockingActive ? SelectedCss : NotSelectedCss} id="EasyClocking" onClick={(e) => this.getID(e, "EasyClocking")}>
                                            <td style={{ 'fontWeight': 'normal' }}>Timeclock File (.dat/.txt)</td>
                                        </tr>
                                        <tr style={this.state.TimelogsActive ? SelectedCss : NotSelectedCss} id="Timelogs" onClick={(e) => this.getID(e, "Timelogs")}>
                                            <td style={{ 'fontWeight': 'normal' }}>CSV File</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                    <div className="col-10">
                        <div className="row">
                            <div className="col-12">
                                {this.renderMigration()}
                            </div>
                        </div><br />
                        <div className="row">
                            <div className="col-12">
                                {
                                    renderImport
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>);
        } else {
            return (<Redirect to={'/login'} />)
        }
    }

    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'} />)
        }

        return (
            <div id="divContainer"><MainLayout /><ToastContainer hideProgressBar key={Math.random() * 10000} />
                <div className="container-fluid" >
                    {

                        this.renderImportFileRow()
                    }
                </div>
            </div>
        );
    }

    renderImportType() {
        if (this.state.LocationsActive)
            return <LocationsImportFile CompanyCode={this.state.CompanyCode} />;

        if (this.state.DepartmentsActive)
            return <DepartmentImportFile CompanyCode={this.state.CompanyCode} />;

        if (this.state.EmployeesActive)
            return <EmployeesImportFile CompanyCode={this.state.CompanyCode} MaxUsers={this.state.MaxUser} />;

        if (this.state.PositionsActive)
            return <PositionsImportFile CompanyCode={this.state.CompanyCode} />;

        if (this.state.ProjectsActive)
            return <ProjectsImportFile CompanyCode={this.state.CompanyCode} />;

        if (this.state.JobsActive)
            return <JobsImportFile CompanyCode={this.state.CompanyCode} />;

        if (this.state.PTOActive)
            return <PTOImportFile CompanyCode={this.state.CompanyCode} />;

        if (this.state.EasyClockingActive)
            return <EasyClockingImportFile CompanyCode={this.state.CompanyCode} />;

        if (this.state.TimelogsActive)
            return <TimelogImportFile CompanyCode={this.state.CompanyCode} />;
    }
    ValidateDate(d) {

        var ActualDate = new Date();
        var DBDate = new Date(d);

        // Compara solo las fechas => no las horas!!
        ActualDate.setHours(0, 0, 0, 0);

        let ret = DBDate < ActualDate ? "badge badge-pill badge-danger" : "badge badge-pill badge-light";
        return ret;

    }
    ValidateMaxUser(MaxUser, ActiveUsers) {
        let ret = parseInt(MaxUser, 10) < parseInt(ActiveUsers, 10) ? "badge badge-pill badge-danger" : "badge badge-pill badge-light";
        return ret;
    }
    renderMigration() {
        return (<div>
            <div className="card Logs">
                <div className="card-body">
                    <div className="row">
                        <div className="col-2">
                            <h4><span className="badge badge-info">Customer Information</span></h4>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2 offset-md-1" style={{ 'paddingBottom': '0.8rem', 'paddingRight': '1.8rem', 'textAlign': 'right' }}>
                            <label className="control-label" style={{ 'paddingTop': '15px', 'fontWeight': 'bold' }}>Company Code</label>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2 " style={{ 'paddingBottom': '0.8rem' }}>
                            <div className="form-group" style={{ 'paddingTop': '7px' }}>
                                <input className="form-control" name="CompanyCode" id="CompanyCode" type="text" onKeyDown={this.hanldeKeyPress} onChange={this.companyCodeValueV} value={this.state.CompanyCode ? this.state.CompanyCode : ""} />
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2 " style={{ 'paddingBottom': '0.8rem' }}>
                            <ClipLoader
                                className={override}
                                sizeUnit={"px"}
                                size={30}
                                color={'#33B5E5'}
                                loading={this.state.loading}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-2" style={{ 'paddingBottom': '0.8rem' }}>
                            <span className="badge badge-pill badge-light">Company Name: {this.state.CompanyName}</span>
                        </div>
                        <div className="col-2" style={{ 'paddingBottom': '0.8rem' }}>
                            <span className="badge badge-pill badge-light">Max Users: {this.state.MaxUser}</span>
                        </div>
                        <div className="col-2" style={{ 'paddingBottom': '0.8rem' }}>
                            <span className={this.ValidateMaxUser(this.state.MaxUser, this.state.UsersActive)} >Users Active: {this.state.UsersActive}</span>
                        </div>
                        <div className="col-2">
                            <span className="badge badge-pill badge-light">Product Code: {this.state.ProductCode}</span>
                        </div>
                        <div className="col-2">
                            <span className={this.ValidateDate(this.state.ExpirationDate.replace("T", " "))} >Expiration Date: {this.state.ExpirationDate.replace("T", " ")}</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>);

    }
}

export default ImportFile;


// WEBPACK FOOTER //
// ./src/ImportFile/ImportFile.jsx